import { typographyDesktop } from '@shared/tokens/typography.desktop.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  calendarInputWrapper: (width: string) => ({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    width: width,
  }),
  closeIconWrapper: {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    lineHeight: 0,
  },
  calendarIconWrapper: {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    lineHeight: 0,
    opacity: 0.7,
    display: 'flex',
    alignItems: 'center',
  },
  calendar: {
    boxSizing: 'border-box',
    position: 'absolute',
    fontFamily: fonts.din2014Regular,
    width: '284px',
    borderRadius: anatomy.borderRadiusS,
    border: `1px solid ${colors.tertiaryBorder}`,
    backgroundColor: colors.primaryBackground,
    zIndex: 100,
  },

  calendarContainer: {
    padding: '16px',
  },

  calendarHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: anatomy['space-16'],
    textTransform: 'capitalize',
    fontWeight: '600',
    fontSize: anatomy['size-16'],
    cursor: 'pointer',
    color: colors.primaryText,
  },
  calendarHeaderTitle: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  calendarHeaderMonthes: {
    marginRight: '2px',
    color: colors.primaryText,
  },
  calendarBody: {},
  calendarWeekNames: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: '1px',
    height: '20px',
    textAlign: 'center',
    alignItems: 'center',
    textTransform: 'capitalize',
    fontSize: anatomy['size-12'],
    fontWeight: '400',
    color: colors.secondaryText,
  },

  calendarDays: {
    fontSize: anatomy['size-16'],
    fontWeight: typographyDesktop.fontWeighRegular,
    lineHeight: typographyDesktop['lineHeightBody-4'],
    fontFamily: fonts.din2014Regular,
    color: colors.primaryText,
    textAlign: 'center',
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gridTemplateRows: '1fr',
  },
  calendarDay: {
    boxSizing: 'border-box',
    backgroundColor: {
      ':hover': colors.ghostBackground,
    },
    borderRadius: anatomy.borderRadiusS,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '36px',
    width: '36px',
  },
  calendarAdditionalDay: {
    color: colors.ghostText,
  },
  calendarSelectedFirstDay: (isRange) => ({
    backgroundColor: colors.brandBackground,
    borderRadius: isRange ? anatomy.borderRadiusS + ' 0 0 ' + anatomy.borderRadiusS : anatomy.borderRadiusS,
    color: colors.primaryInverseText,
  }),
  calendarSelectedEndDay: {
    backgroundColor: colors.brandBackground,
    borderRadius: '0 ' + anatomy.borderRadiusS + ' ' + anatomy.borderRadiusS + ' 0',
    color: colors.primaryInverseText,
  },
  calendarTodayItem: {
    color: colors.primaryInverseText,
    backgroundColor: colors.accentBackground,
    borderRadius: anatomy.borderRadiusS,
  },
  calendarPickItemContainer: {
    textAlign: 'center',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(4, 1fr)',
    gap: '1px 1px',
  },
  calendarPickItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '84px',
    height: '52px',
    textAlign: 'center',
    backgroundColor: {
      ':hover': colors.ghostBackground,
    },
    fontWeight: '400',
    textTransform: 'capitalize',
    borderRadius: anatomy.borderRadiusS,
    fontSize: anatomy['size-16'],
    cursor: 'pointer',
    color: colors.primaryText,
  },
  calendarDaysInRange: {
    borderRadius: '0',
    backgroundColor: {
      ':hover': colors.ghostBackground,
      default: colors.ghostBackground,
    },
  },
  calendarHoveredDay: {
    backgroundColor: colors.ghostBackground,
    borderRadius: '0',
  },
  calendarSelectedItem: {},
});
